import { Flex, FlexProps } from '@cmpsr/components';

interface QuestionnaireLayoutProps extends FlexProps {
  children: React.ReactNode;
}

export default function Layout({ children, ...props }: QuestionnaireLayoutProps): React.ReactElement {
  return (
    <Flex flexDirection="column" minHeight="100svh" background="primary-default" {...props}>
      {children}
    </Flex>
  );
}
